<template>
  <div class="searchBar">
    <el-form :model="searchParams">
      <el-form-item>
        <label-input
          v-model="storeName"
          class="label-input"
          width="368px"
          label-width="94px"
          label="药店名称"
          type="autocomplete"
        />
      </el-form-item>
      <el-form-item>
        <el-select v-model="serverType" placeholder="服务类型">
          <el-option v-for="(value, key) in serviceType" :key="key" :label="value" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="startTime"
          class="zy-date-picker"
          type="date"
          placeholder="开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="endTime"
          class="zy-date-picker"
          type="date"
          placeholder="结束时间"
          value-format="yyyy-MM-dd"
          clearable
        />
      </el-form-item>
      <el-button class="el-button--primary is-plain btn" @click="$emit('search')">查询</el-button>
      <el-button class="el-button--primary  btn" @click="$emit('reset')">重置</el-button>
    </el-form>
  </div>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Constant from '@/lib/constant';
export default {
  props: {
    searchParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    labelInput
  },
  computed: {
    storeName: {
      get() {
        return this.searchParams.storeName;
      },
      set(val) {
        this.$emit('change', 'storeName', val);
      }
    },
    serverType: {
      get() {
        return this.searchParams.serverType;
      },
      set(val) {
        this.$emit('change', 'serverType', val);
      }
    },
    date: {
      get() {
        const { startTime, endTime } = this.searchParams;
        return [startTime, endTime];
      }
    },
    startTime: {
      get() {
        const { startTime } = this.searchParams;
        return startTime;
      },
      set(value) {
        this.$emit('change', 'startTime', value);
      }
    },
    endTime: {
      get() {
        const { endTime } = this.searchParams;
        return endTime;
      },
      set(value) {
        if (value) value = `${value} 23:59:59`;
        this.$emit('change', 'endTime', value);
      }
    }
  },
  data() {
    return {
      serviceType: Constant.serviceType
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.searchBar {
  .el-form {
    .el-form-item {
      display: inline-block;
      margin-right: 20px;
    }
  }
}
</style>
